var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FieldWrapper } from '@dixa/lib-shared-habla';
import { PureComponent } from 'react';
import { CategorizedMultiSelectCategory } from './categorizedMultiSelectCategory';
import styles from './fieldCategorizedMultiSelect.module.scss';
export class FieldCategorizedMultiSelect extends PureComponent {
    hasError() {
        const { meta } = this.props;
        if (meta.error) {
            return meta.touched === undefined || meta.touched === true;
        }
        return false;
    }
    getErrorMessage() {
        if (this.hasError()) {
            const { meta } = this.props;
            return meta.error;
        }
        return undefined;
    }
    render() {
        const _a = this.props, { label, required, categoryOptions, input, readOnly = false } = _a, otherProps = __rest(_a, ["label", "required", "categoryOptions", "input", "readOnly"]);
        return (_jsx(FieldWrapper, Object.assign({ label: label, required: required, labelFor: input.name, meta: {
                error: this.getErrorMessage(),
            }, className: styles.root }, { children: _jsx("div", Object.assign({ className: styles.container }, { children: categoryOptions.map((cat) => {
                    return (_jsx(CategorizedMultiSelectCategory, Object.assign({ readOnly: readOnly, input: input }, otherProps, { category: cat }), cat.categoryName));
                }) })) })));
    }
}
